import React from 'react'
import { connect } from 'react-redux'
import { addListItem, getFormValue } from '../../public/utility'
class SendEmailFormDiv extends React.Component {
    state = {
        changedValues基本信息: {},
        flowRecordId: this.props.flowRecordId,
        id: this.props.id,
        emailTemplet: this.props.emailTemplet,
    }

    componentDidMount = () => {
        const { SupplierID } = this.props
        this.doSendEmailForm(SupplierID)
    }
    componentWillUnmount = () => {
        this.unmount = true
    }
    doSendEmailForm = (SupplierID) => {
        const { emailTemplet } = this.state
        Tyan.doPostEvent({
            event: 'GetSendEmailForm',
            data: { SupplierID, emailTemplet },
            onEnd: ({ errorMessage, initValues基本信息, 附件, optionsParas }) => {
                if (errorMessage)
                    Tyan.pubForm.showError(errorMessage)
                else {
                    if (附件.length > 0) {
                        附件.map(o => addListItem(this, { ...o }, '基本信息', '附件'))
                    }
                    this.setState({ initValues基本信息, SupplierID, optionsParas })
                }
            }
        })
    }

    canSave = () => {
        const 收件人 = getFormValue(this, '基本信息', '收件人')
        return getFormValue(this, '基本信息', '主题')
            && 收件人 && 收件人.length > 0
            && getFormValue(this, '基本信息', '邮件内容')
    }

    handleSendMail = () => {
        const { SupplierID, initValues基本信息, changedValues基本信息, emailTemplet } = this.state
        const { onSave, onClose } = this.props
        var newChangedValues = { ...initValues基本信息, ...changedValues基本信息 }
        Tyan.doPostEvent({
            event: 'SaveSendEmailForm',
            data: { SupplierID, changedValues基本信息: newChangedValues, emailTemplet },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                Ext.toast('保存成功')
                onSave && onSave()
                onClose && onClose()
            }
        })
    }

    fieldset邮件信息 = () => {
        return [
            { _text: '主题', name: '主题', minWidth: '95%', required: true },
            { _select: '收件人', name: '收件人', minWidth: '95%', multiSelect: true, editable: true, forceSelection: false, required: true },
            { _select: '抄送', name: '抄送', minWidth: '95%', multiSelect: true, editable: true, forceSelection: false, },
            { _text: '邮件内容', minWidth: '95%', maxRows: 10, required: true },
            { _files: '附件' }
        ]
    }

    render() {
        const { showMessage: Message, onClose, showBody: Body } = this.props
        const { errorMessage, initValues基本信息 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} minWidth="800" maxWidth="1100"
            controls={[
                { _button: '发送', icon: 'envelope-o', handler: () => this.handleSendMail(), disabled: !this.canSave() },
                { _button: '关闭', icon: 'close', handler: () => onClose && onClose() }
            ]}
            fieldsets={[{ title: '', name: '基本信息', _fieldset: this.fieldset邮件信息() }]}
        />
    }
}

export default connect()(SendEmailFormDiv)